import { ConsumerEntity } from '../../consumer/consumer.entity';
import { Relation } from '../../core/decorators/relation.decorator';
import { BaseEntity } from '../../core/entities/base.entity';
import { ConsumerData } from '../../core/types';
import { RelationRef } from '../../core/types/entity-types';
import { LearnItemConfig, QuantityError } from '../../lesson/exercise/exercise.entity';
import { SequenceEntity } from '../../sequence/sequence.entity';
import { SubjectEntity } from '../../subject/subject.entity';

export interface ExamKind {
  value: string
  option: string
}

export interface ExamConsumer {
  id: string
  name: string
}

export interface ExamCompetency {
  id: string
  name: string
}

export class ExamEntity extends BaseEntity {
  subjectId!: string;
  consumerId!: string;
  name!: string;
  kind!: string;
  config!: LearnItemConfig;
  assignments!: string[];
  assets!: string[];
  updated!: Date;
  version!: number;
  approval!: string;
  active!: boolean;
  lastVersion!: string;
  sortName!: string;
  correct!: string[];
  changedBy!: string;
  copyRestricted!: boolean;
  consumerData!: ConsumerData;
  pages!: string[];
  conditionalErrors!: string[];
  quantityErrors!: QuantityError[];

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];

  @Relation()
  sequences?: RelationRef<SequenceEntity>[];
}
